import { FormArray, FormControl, FormGroup } from '@angular/forms';
import {
  CompanyAddressFormModel,
  CustomerCompanyAddressModel,
} from '@registration/interfaces';
import { FacilityCo2Type, FacilityH2Type } from '@enums';

export enum DefaultUnitTypeEnum {
  MWH_H = 'mwh-h',
  MWH = 'mwh',
  KWH_H = 'kwh-h',
  KWH = 'kwh',
  KG_H = 'kg-h',
  KG = 'kg',
}

export enum AlternativeTransportEnum {
  NONE = 0,
  ZUG = 1,
  SCHIFF = 2,
  LKW = 4,
  FREITEXT = 8,
}

export enum CustomerDeclaration {
  NONE = 31,
  YES = 32,
  NO = 33,
}

export enum EmissionType {
  None = 21,
  Process = 22,
  Energy = 23,
  ProcessAndEnergy = 24,
}

export enum HydrogenQualityEnum {
  NONE = 41,
  GROUP_A = 42,
  GROUP_NEW = 43,
  GROUP_D = 44,
}

export enum HydrogenUtilizationEnum {
  NONE = 51,
  MATERIAL = 52,
  ENERGETIC = 53,
  SPACE_HEATING = 54,
}

export enum HydrogenSectorOfLocationEnum {
  NONE = 61,
  ELECTROLYSIS = 62,
  POWER_STATIONS = 63,
  CHEMICAL = 64,
  TRANSPORTATION = 65,
  VEHICLE_CONSTRUCTION = 66,
  STEEL_METAL_INDUSTRY = 67,
  PAPER_INDUSTRY = 68,
  GLASS_CERAMICS_INDUSTRY = 69,
  EXTRACTION_PROCESSING = 71,
  FOOD_INDUSTRY = 72,
  REFINERIES = 73,
  COMMERCE = 74,
  HOUSEHOLDS = 75,
  STORAGES = 76,
}

export enum StartMonthOfTransportationRequirements {
  JANUARY = 1,
  FEBRUARY = 2,
  MARCH = 3,
  APRIL = 4,
  MAY = 5,
  JUNE = 6,
  JULY = 7,
  AUGUST = 8,
  SEPTEMBER = 9,
  OCTOBER = 10,
  NOVEMBER = 11,
  DECEMBER = 12,
}

export interface RegisterFacilityFormSmall {
  facility: FormGroup<BaseFacilityForm>;
  vnb: FormControl<number>;
  legal: FormControl<boolean>;
  policy: FormControl<boolean>;
}

export interface RegisterH2FacilityForm {
  facility: FormGroup<H2FacilityForm>;
  capacity: FormGroup<UnitForm>;
  energy: FormGroup<UnitForm>;
  vnb: FormControl<number>;
  legal: FormControl<boolean>;
  policy: FormControl<boolean>;
}

export interface RegisterCo2FacilityForm {
  facilityOwnerEmail: FormControl<string | undefined>;
  facility: FormGroup<Co2FacilityForm>;
  consume_list: FormArray<FormGroup<Co2YearFormGroup>>;
  produce_list: FormArray<FormGroup<Co2YearFormGroup>>;
  alternativeTransportTypeId: FormControl<AlternativeTransportEnum[]>;
  alternativeTransport: FormControl<string>;
  customerDeclaration: FormControl<string>;
  customerDeclarationTypeId: FormControl<CustomerDeclaration>;
  transportTarget: FormControl<string>;
  separatorsTechnology: FormControl<string>;
  separatorsCleaningCoasts: FormControl<number>;
  maintenanceWindow1: FormGroup<Co2MaintenanceWindow>;
  maintenanceWindow2: FormGroup<Co2MaintenanceWindow>;
  maintenanceWindow3: FormGroup<Co2MaintenanceWindow>;
  description: FormControl<string>;
  sharingWithAuthorities: FormControl<boolean>;
  sharingWithThirdParty: FormControl<boolean>;
}

export interface BaseFacilityForm {
  companyAddress: FormGroup<CompanyAddressFormModel>;
}

export interface H2FacilityForm extends BaseFacilityForm {
  requirementProduction: FormControl<FacilityH2Type | undefined>;
  facilityName: FormControl<string | undefined>;
  maloId: FormControl<number | undefined>;
  hydrogenQuality: FormControl<number | undefined>;
  requiredPressure: FormControl<number | undefined>;
  hydrogenUtilization: FormControl<number | undefined>;
  sectorOfLocation: FormControl<number | undefined>;
  descriptionLocation: FormControl<string | undefined>;
  facilityOwnerEmail: FormControl<string | undefined>;
}

export interface Co2FacilityForm extends BaseFacilityForm {
  typeId: FormControl<FacilityCo2Type>;
  facilityName: FormControl<string>;
  firstYearOfTransportCapability: FormControl<number>;
  emissionTypeId: FormControl<EmissionType>;
  startMonthOfTransportationRequirements: FormControl<StartMonthOfTransportationRequirements>;
  willingnessPayValueChain: FormControl<number>;
}

export interface UnitForm {
  unit: FormControl<DefaultUnitTypeEnum | undefined>;
  years: FormGroup;
}

export interface Co2YearFormGroup {
  year: FormControl<number>;
  ton: FormControl<number>;
  bio_ratio: FormControl<number>;
  hour: FormControl<number>;
  peak_in_t_per_h: FormControl<number>;
}

export interface Co2MaintenanceWindow {
  start: FormControl<string>;
  end: FormControl<string>;
}

export interface RegisterFacilityModel {
  facility: {
    requirementProduction: FacilityH2Type;
    facilityName: string;
    companyAddress: CustomerCompanyAddressModel;
    maloId: number;
    hydrogenQuality: number;
    requiredPressure: number;
    hydrogenUtilization: number;
    sectorOfLocation: number;
    descriptionLocation: string;
    facilityOwnerEmail: string;
  };
  vnb: number;
  capacity: {
    unit: DefaultUnitTypeEnum;
    years: any;
  };
  energy: {
    unit: DefaultUnitTypeEnum;
    years: any;
  };
}
